import { v4 as uuidv4 } from 'uuid';

export function DisclosureContent(props, childrenComponents = []) {
	return {
		componentName: 'DisclosureContent',
		componentId: uuidv4(),
		props: Object.assign(
			{
				...props,
			},
			props,
		),
		childrenComponents,
	};
}
